import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Storage = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.50499 10.4346L6.43467 9.27415C6.43894 9.27289 6.44337 9.27225 6.44783 9.27226L53.61 9.33036C53.6145 9.33036 53.6188 9.331 53.6231 9.33225L57.5528 10.4927C58.6642 10.8182 58.9806 11.5583 58.9999 11.8876L58.6526 48.7933C58.6063 49.3047 58.1317 49.4326 57.9001 49.4326L1.87296 49.665C1.86984 49.665 1.86661 49.6647 1.86355 49.6641C1.28921 49.5467 1.25078 49.1608 1.23154 48.9676L1 11.8876C1.04631 11.0507 2.02262 10.5702 2.50499 10.4346Z"
            fill="url(#nas_paint0_linear_13984_69427)"
            stroke="black"
            stroke-width="0.115651"
          />
          <path
            d="M47.6074 12.3794H57.8438C58.4825 12.3794 59.0003 12.8972 59.0003 13.5359V46.4371C59.0003 47.0758 58.4825 47.5936 57.8437 47.5936H47.6074V12.3794Z"
            fill="url(#nas_paint1_linear_13984_69427)"
          />
          <rect
            x="49.7221"
            y="35.2084"
            width="8.19896"
            height="5.09182"
            rx="0.303589"
            fill="#73B3CE"
            stroke="#323F43"
            stroke-width="0.0867397"
          />
          <rect
            x="50.8999"
            y="38.2206"
            width="0.433697"
            height="6.21428"
            rx="0.173479"
            transform="rotate(-90 50.8999 38.2206)"
            fill="#22627B"
          />
          <path
            d="M1 12.3794H48.6428V21.7008H1V12.3794Z"
            fill="url(#nas_paint2_linear_13984_69427)"
          />
          <rect
            x="43.9646"
            y="14.6498"
            width="1.38782"
            height="3.70084"
            fill="url(#nas_paint3_linear_13984_69427)"
            stroke="#195167"
            stroke-width="0.115651"
          />
          <rect
            x="43.9646"
            y="14.6498"
            width="1.38782"
            height="1.85042"
            fill="url(#nas_paint4_linear_13984_69427)"
            stroke="#195167"
            stroke-width="0.115651"
          />
          <path
            d="M54.934 29.46C55.3549 29.8809 55.3549 30.5635 54.934 30.9845C54.513 31.4054 53.8304 31.4054 53.4095 30.9845C52.9885 30.5635 52.9885 29.8809 53.4095 29.46"
            stroke="url(#nas_paint5_linear_13984_69427)"
            stroke-width="0.323387"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M54.1719 29.1443V30.2222"
            stroke="url(#nas_paint6_linear_13984_69427)"
            stroke-width="0.323387"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="1"
            y="44.7164"
            width="16.1109"
            height="3.22218"
            fill="url(#nas_paint7_linear_13984_69427)"
          />
          <rect
            x="1"
            y="22.1611"
            width="12.8887"
            height="19.3331"
            fill="url(#nas_paint8_linear_13984_69427)"
          />
          <rect
            x="1"
            y="22.1611"
            width="16.1109"
            height="19.3331"
            fill="url(#nas_paint9_linear_13984_69427)"
          />
          <g filter="url(#filter0_i_13984_69427)">
            <rect
              x="1"
              y="41.4943"
              width="16.1109"
              height="3.22218"
              fill="url(#nas_paint10_linear_13984_69427)"
            />
          </g>
          <rect
            x="1.23096"
            y="44.6615"
            width="16.1109"
            height="0.578257"
            fill="#12495D"
          />
          <path
            opacity="0.2"
            d="M10.5864 36.713C10.5864 37.5895 9.89881 38.2957 9.05591 38.2957C8.21302 38.2957 7.52538 37.5895 7.52538 36.713C7.52538 35.8365 8.21302 35.1304 9.05591 35.1304C9.89881 35.1304 10.5864 35.8365 10.5864 36.713Z"
            fill="#233838"
            stroke="black"
            stroke-width="0.161109"
          />
          <ellipse
            cx="9.05403"
            cy="36.7137"
            rx="1.12776"
            ry="1.16422"
            fill="#29637B"
          />
          <path
            d="M9.82081 36.7131C9.82081 37.1513 9.47699 37.5044 9.05554 37.5044C8.6341 37.5044 8.29028 37.1513 8.29028 36.7131C8.29028 36.2748 8.6341 35.9217 9.05554 35.9217C9.47699 35.9217 9.82081 36.2748 9.82081 36.7131Z"
            fill="url(#nas_paint11_linear_13984_69427)"
            stroke="#1B556F"
            stroke-width="0.0805544"
          />
          <rect
            x="16.5361"
            y="44.7164"
            width="16.1109"
            height="3.22218"
            fill="url(#nas_paint12_linear_13984_69427)"
          />
          <rect
            x="16.5361"
            y="22.1611"
            width="12.8887"
            height="19.3331"
            fill="url(#nas_paint13_linear_13984_69427)"
          />
          <rect
            x="16.5361"
            y="22.1611"
            width="16.1109"
            height="19.3331"
            fill="url(#nas_paint14_linear_13984_69427)"
          />
          <g filter="url(#filter1_i_13984_69427)">
            <rect
              x="16.5361"
              y="41.4943"
              width="16.1109"
              height="3.22218"
              fill="url(#nas_paint15_linear_13984_69427)"
            />
          </g>
          <rect
            x="16.7671"
            y="44.6615"
            width="16.1109"
            height="0.578257"
            fill="#12495D"
          />
          <path
            opacity="0.2"
            d="M26.1216 36.713C26.1216 37.5895 25.434 38.2957 24.5911 38.2957C23.7482 38.2957 23.0605 37.5895 23.0605 36.713C23.0605 35.8365 23.7482 35.1304 24.5911 35.1304C25.434 35.1304 26.1216 35.8365 26.1216 36.713Z"
            fill="#233838"
            stroke="black"
            stroke-width="0.161109"
          />
          <ellipse
            cx="24.5892"
            cy="36.7137"
            rx="1.12776"
            ry="1.16422"
            fill="#29637B"
          />
          <path
            d="M25.3569 36.7131C25.3569 37.1513 25.0131 37.5044 24.5917 37.5044C24.1702 37.5044 23.8264 37.1513 23.8264 36.7131C23.8264 36.2748 24.1702 35.9217 24.5917 35.9217C25.0131 35.9217 25.3569 36.2748 25.3569 36.7131Z"
            fill="url(#nas_paint16_linear_13984_69427)"
            stroke="#1B556F"
            stroke-width="0.0805544"
          />
          <rect
            x="32.0713"
            y="44.7164"
            width="16.1109"
            height="3.22218"
            fill="url(#nas_paint17_linear_13984_69427)"
          />
          <rect
            x="32.0713"
            y="22.1611"
            width="12.8887"
            height="19.3331"
            fill="url(#nas_paint18_linear_13984_69427)"
          />
          <rect
            x="32.0713"
            y="22.1611"
            width="16.1109"
            height="19.3331"
            fill="url(#nas_paint19_linear_13984_69427)"
          />
          <g filter="url(#filter2_i_13984_69427)">
            <rect
              x="32.0713"
              y="41.4943"
              width="16.1109"
              height="3.22218"
              fill="url(#nas_paint20_linear_13984_69427)"
            />
          </g>
          <rect
            x="32.3022"
            y="44.6615"
            width="16.1109"
            height="0.578257"
            fill="#12495D"
          />
          <path
            opacity="0.2"
            d="M41.6577 36.713C41.6577 37.5895 40.9701 38.2957 40.1272 38.2957C39.2843 38.2957 38.5967 37.5895 38.5967 36.713C38.5967 35.8365 39.2843 35.1304 40.1272 35.1304C40.9701 35.1304 41.6577 35.8365 41.6577 36.713Z"
            fill="#233838"
            stroke="black"
            stroke-width="0.161109"
          />
          <ellipse
            cx="40.1253"
            cy="36.7137"
            rx="1.12776"
            ry="1.16422"
            fill="#29637B"
          />
          <path
            d="M40.8921 36.7131C40.8921 37.1513 40.5483 37.5044 40.1268 37.5044C39.7054 37.5044 39.3616 37.1513 39.3616 36.7131C39.3616 36.2748 39.7054 35.9217 40.1268 35.9217C40.5483 35.9217 40.8921 36.2748 40.8921 36.7131Z"
            fill="url(#nas_paint21_linear_13984_69427)"
            stroke="#1B556F"
            stroke-width="0.0805544"
          />
          <rect
            x="3.19873"
            y="14.5922"
            width="0.578257"
            height="38.0493"
            rx="0.231303"
            transform="rotate(-90 3.19873 14.5922)"
            fill="#195167"
          />
          <rect
            x="3.19873"
            y="16.2112"
            width="0.578257"
            height="38.0493"
            rx="0.231303"
            transform="rotate(-90 3.19873 16.2112)"
            fill="#195167"
          />
          <rect
            x="3.19873"
            y="17.8307"
            width="0.578257"
            height="38.0493"
            rx="0.231303"
            transform="rotate(-90 3.19873 17.8307)"
            fill="#195167"
          />
          <rect
            x="3.19873"
            y="19.4492"
            width="0.578257"
            height="38.0493"
            rx="0.231303"
            transform="rotate(-90 3.19873 19.4492)"
            fill="#195167"
          />
          <path
            d="M4.58594 50.4562V49.3337C4.58594 49.3082 4.60665 49.2875 4.6322 49.2875H11.0162C11.0417 49.2875 11.0624 49.3082 11.0624 49.3337V50.2782C11.0624 50.2908 11.057 50.3031 11.0479 50.3118C8.90556 52.3396 5.87767 51.2878 4.60695 50.4949C4.59348 50.4865 4.58594 50.4721 4.58594 50.4562Z"
            fill="url(#nas_paint22_linear_13984_69427)"
          />
          <path
            d="M48.9946 50.4562V49.3337C48.9946 49.3082 49.0153 49.2875 49.0409 49.2875H55.4248C55.4504 49.2875 55.4711 49.3082 55.4711 49.3337V50.2782C55.4711 50.2908 55.4657 50.3031 55.4566 50.3118C53.3142 52.3396 50.2864 51.2878 49.0156 50.4949C49.0022 50.4865 48.9946 50.4721 48.9946 50.4562Z"
            fill="url(#nas_paint23_linear_13984_69427)"
          />
          <defs>
            <filter
              id="filter0_i_13984_69427"
              x="1"
              y="41.4943"
              width="16.1108"
              height="3.68477"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="0.462606" />
              <feGaussianBlur stdDeviation="0.231303" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_13984_69427"
              />
            </filter>
            <filter
              id="filter1_i_13984_69427"
              x="16.5361"
              y="41.4943"
              width="16.1108"
              height="3.68477"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="0.462606" />
              <feGaussianBlur stdDeviation="0.231303" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_13984_69427"
              />
            </filter>
            <filter
              id="filter2_i_13984_69427"
              x="32.0713"
              y="41.4943"
              width="16.1108"
              height="3.68477"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="0.462606" />
              <feGaussianBlur stdDeviation="0.231303" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_13984_69427"
              />
            </filter>
            <linearGradient
              id="nas_paint0_linear_13984_69427"
              x1="30"
              y1="9.27225"
              x2="30"
              y2="49.665"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1F6074" />
              <stop offset="0.0001" stop-color="#1E6074" />
              <stop offset="0.51" stop-color="#1C5A6D" />
              <stop offset="1" stop-color="#23667A" />
            </linearGradient>
            <linearGradient
              id="nas_paint1_linear_13984_69427"
              x1="53.3038"
              y1="12.3794"
              x2="53.3038"
              y2="47.5936"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1F6282" />
              <stop offset="0.54" stop-color="#1E5F7B" />
              <stop offset="1" stop-color="#176386" />
            </linearGradient>
            <linearGradient
              id="nas_paint2_linear_13984_69427"
              x1="24.8214"
              y1="12.3794"
              x2="24.8214"
              y2="21.7008"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#23728D" />
              <stop offset="0.5" stop-color="#29718B" />
              <stop offset="1" stop-color="#184D5E" />
            </linearGradient>
            <linearGradient
              id="nas_paint3_linear_13984_69427"
              x1="44.6585"
              y1="14.592"
              x2="44.6585"
              y2="18.4085"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B0B0B0" />
              <stop offset="1" stop-color="#4C646A" stop-opacity="0.99" />
            </linearGradient>
            <linearGradient
              id="nas_paint4_linear_13984_69427"
              x1="44.6585"
              y1="14.592"
              x2="44.6585"
              y2="16.5581"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B0B0B0" />
              <stop offset="1" stop-color="#4C646A" stop-opacity="0.99" />
            </linearGradient>
            <linearGradient
              id="nas_paint5_linear_13984_69427"
              x1="54.1717"
              y1="29.46"
              x2="54.1717"
              y2="31.3002"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D2CDCD" />
              <stop
                offset="0.525"
                stop-color="#CBCBCB"
                stop-opacity="0.99475"
              />
              <stop offset="1" stop-color="#9E9E9E" stop-opacity="0.99" />
            </linearGradient>
            <linearGradient
              id="nas_paint6_linear_13984_69427"
              x1="54.1719"
              y1="29.1443"
              x2="54.1719"
              y2="30.2222"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D2CDCD" />
              <stop
                offset="0.525"
                stop-color="#CBCBCB"
                stop-opacity="0.99475"
              />
              <stop offset="1" stop-color="#9E9E9E" stop-opacity="0.99" />
            </linearGradient>
            <linearGradient
              id="nas_paint7_linear_13984_69427"
              x1="9.05544"
              y1="44.7164"
              x2="9.05544"
              y2="47.9385"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#28627E" />
              <stop offset="0.54" stop-color="#176082" />
              <stop offset="1" stop-color="#14516D" />
            </linearGradient>
            <linearGradient
              id="nas_paint8_linear_13984_69427"
              x1="7.44435"
              y1="22.1611"
              x2="7.44435"
              y2="41.4942"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4B5559" />
              <stop offset="1" stop-color="#48575E" />
            </linearGradient>
            <linearGradient
              id="nas_paint9_linear_13984_69427"
              x1="1"
              y1="30.2165"
              x2="17.1109"
              y2="30.2165"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.76" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="nas_paint10_linear_13984_69427"
              x1="9.05544"
              y1="41.4943"
              x2="9.05544"
              y2="44.7164"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#26627E" />
              <stop offset="1" stop-color="#2B607A" />
            </linearGradient>
            <linearGradient
              id="nas_paint11_linear_13984_69427"
              x1="9.05554"
              y1="35.8815"
              x2="9.05554"
              y2="37.5446"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#589DB9" />
              <stop offset="1" stop-color="#4A8BA5" />
            </linearGradient>
            <linearGradient
              id="nas_paint12_linear_13984_69427"
              x1="24.5916"
              y1="44.7164"
              x2="24.5916"
              y2="47.9385"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#28627E" />
              <stop offset="0.54" stop-color="#176082" />
              <stop offset="1" stop-color="#14516D" />
            </linearGradient>
            <linearGradient
              id="nas_paint13_linear_13984_69427"
              x1="22.9805"
              y1="22.1611"
              x2="22.9805"
              y2="41.4942"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4B5559" />
              <stop offset="1" stop-color="#48575E" />
            </linearGradient>
            <linearGradient
              id="nas_paint14_linear_13984_69427"
              x1="16.5361"
              y1="30.2165"
              x2="32.647"
              y2="30.2165"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.76" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="nas_paint15_linear_13984_69427"
              x1="24.5916"
              y1="41.4943"
              x2="24.5916"
              y2="44.7164"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#26627E" />
              <stop offset="1" stop-color="#2B607A" />
            </linearGradient>
            <linearGradient
              id="nas_paint16_linear_13984_69427"
              x1="24.5917"
              y1="35.8815"
              x2="24.5917"
              y2="37.5446"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#589DB9" />
              <stop offset="1" stop-color="#4A8BA5" />
            </linearGradient>
            <linearGradient
              id="nas_paint17_linear_13984_69427"
              x1="40.1267"
              y1="44.7164"
              x2="40.1267"
              y2="47.9385"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#28627E" />
              <stop offset="0.54" stop-color="#176082" />
              <stop offset="1" stop-color="#14516D" />
            </linearGradient>
            <linearGradient
              id="nas_paint18_linear_13984_69427"
              x1="38.5156"
              y1="22.1611"
              x2="38.5156"
              y2="41.4942"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4B5559" />
              <stop offset="1" stop-color="#48575E" />
            </linearGradient>
            <linearGradient
              id="nas_paint19_linear_13984_69427"
              x1="32.0713"
              y1="30.2165"
              x2="48.1822"
              y2="30.2165"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.76" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="nas_paint20_linear_13984_69427"
              x1="40.1267"
              y1="41.4943"
              x2="40.1267"
              y2="44.7164"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#26627E" />
              <stop offset="1" stop-color="#2B607A" />
            </linearGradient>
            <linearGradient
              id="nas_paint21_linear_13984_69427"
              x1="40.1268"
              y1="35.8815"
              x2="40.1268"
              y2="37.5446"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#589DB9" />
              <stop offset="1" stop-color="#4A8BA5" />
            </linearGradient>
            <linearGradient
              id="nas_paint22_linear_13984_69427"
              x1="7.82418"
              y1="49.2875"
              x2="7.82418"
              y2="51.4849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#41555D" />
              <stop offset="0.5" stop-color="#132025" />
              <stop offset="1" stop-color="#111C20" />
            </linearGradient>
            <linearGradient
              id="nas_paint23_linear_13984_69427"
              x1="52.2329"
              y1="49.2875"
              x2="52.2329"
              y2="51.4849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#41555D" />
              <stop offset="0.5" stop-color="#132025" />
              <stop offset="1" stop-color="#111C20" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default Storage;
